import BaseRequest from '../baseRequest';
import { IBaseRequestOptions } from '../baseRequest/types';

import {
  IGetUploadUrlResponse,
  IResult,
  IResultSuccess,
  IResultFailure,
  IResultError,
  IUploadFileResponse,
} from './types';

class SingleToolsApi extends BaseRequest {
  constructor(protected readonly options: IBaseRequestOptions) {
    super(options);
  }

  async uploadFile(file: File): Promise<IUploadFileResponse> {
    const { uploadUrl, ...rest } = await this.getUploadUrl(file.type);
    const axios = await this.axios;
    await axios.put(uploadUrl, file, {
      headers: { 'Content-Type': file.type },
    });

    return rest;
  }

  async pollResults(
    ids: string[],
    triesLeft: number = this.options.poolMaxTries,
  ): Promise<(IResultSuccess | IResultFailure | IResultError)[]> {
    const results = await this.getResults(ids);

    if (triesLeft <= 1) {
      return results.map((r) => (r.status === 'pending' ? { id: r.id, status: 'failed' } : r));
    }

    const anyPending = results.some((r) => r.status === 'pending');
    if (anyPending) {
      return delay(
        () => this.pollResults(ids, triesLeft ? triesLeft - 1 : undefined),
        this.options.poolInterval ?? 1000,
      );
    }

    return results as IResultSuccess[];
  }

  protected async getUploadUrl(contentType?: string): Promise<IGetUploadUrlResponse> {
    const res = await this.get('/get-upload-url', { params: { contentType } });

    return res.data;
  }

  protected async getResults(ids: string[]): Promise<IResult[]> {
    const res = await this.post('/get-result', { ids });

    return res.data;
  }
}

async function delay<T>(fn: () => Promise<T>, time: number): Promise<T> {
  return new Promise<T>((resolve) => {
    setTimeout(() => {
      resolve(fn());
    }, time);
  });
}

export default SingleToolsApi;
